import {
  APPLY_PREPAIDCARD_SUCCESS,
  APPLY_PREPAIDCARD_FAILED,
  APPLY_PREPAIDCARD_INVALID_REQUEST,
  APPLY_PREPAIDCARD_INVALID_CURRENCY,
  LOADING_APPLY_PREPAIDCARD,
  RESET_APPLY_PREPAIDCARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  notFound: false,
  invalidCurrency: false,
  status: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_APPLY_PREPAIDCARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        notFound: false,
        invalidCurrency: false,
        status: ""
      };
    case APPLY_PREPAIDCARD_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        invalidRequest: false,
        success: false,
        notFound: false,
        invalidCurrency: false,
        status: action.payload.status
      };
    case APPLY_PREPAIDCARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: true,
        success: false,
        notFound: false,
        invalidCurrency: false,
        status: action.payload.status
      };

    case APPLY_PREPAIDCARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        success: true,
        notFound: false,
        invalidCurrency: false,
        status: action.payload.status
      };

    case APPLY_PREPAIDCARD_INVALID_CURRENCY:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        success: true,
        notFound: false,
        invalidCurrency: true,
        status: action.payload.status
      };

    case RESET_APPLY_PREPAIDCARD:
      return (state = initialState);

    default:
      return state;
  }
};
